import(/* webpackMode: "eager" */ "/vercel/path0/src/app/data-explorer/page.tsx");
